import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "task-mgmt-list" }

import TaskRecordList from '../components/task-record-list.vue';
import ActivityList from '../components/activity-list.vue';
import taskSummaryList from '../components/task-summary-list.vue';

import { ref, computed } from 'vue';
import { BaseTabs, BaseTabPane } from 'xrk-components';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { useRoute, useRouter } from 'vue-router';
import { ProjectType } from '../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-mgmt-list',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const pageType = ref(route.query.pageName || 'taskRecord');

const changePageType = () => {
  router.replace({
    query: { pageName: pageType.value, force: Date.now() }
  });
};

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);

const projectType = computed<ProjectType>(() => {
  return projectInfo.value.sceneType;
});
//协定服务上传来源1ASP上传2C端上传3双方共同上传
const agreementServiceUploadType = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadType;
});

//协定服务上传方式1以活动方式上传2以人为维度上传
const agreementServiceUploadMode = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadMode;
});

const isEntry = [
  +agreementServiceUploadMode.value,
  +agreementServiceUploadType.value
].join(',');
const isActivity = ['1,1', '1,3'].includes(isEntry);
const showActivity = +projectType.value === 19 && isActivity;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_unref(BaseTabs), {
        onTabChange: changePageType,
        modelValue: pageType.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageType).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseTabPane), {
            label: "任务记录",
            name: "taskRecord"
          }),
          (_unref(showActivity))
            ? (_openBlock(), _createBlock(_unref(BaseTabPane), {
                key: 0,
                label: "活动列表",
                name: "activity"
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(BaseTabPane), {
            label: "任务汇总",
            name: "taskSummary"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (pageType.value === 'taskRecord')
        ? (_openBlock(), _createBlock(TaskRecordList, { key: 0 }))
        : _createCommentVNode("", true),
      (pageType.value === 'taskSummary')
        ? (_openBlock(), _createBlock(taskSummaryList, { key: 1 }))
        : _createCommentVNode("", true),
      (pageType.value === 'activity')
        ? (_openBlock(), _createBlock(ActivityList, { key: 2 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})